import React, {useEffect, useState} from 'react';
import {useT} from '../helpers/i18n';
import useCollapse from 'react-collapsed';
import { className } from 'postcss-selector-parser';

import Checkers from '../helpers/class/Checkers';

import RightModal from './templates/properties/partials/RightModal';
import {btnTextColor} from "../helpers/MethodHelper";

export default function ReadMoreText ( props ) {
  const t = useT();

  const overviewParagraphsLimit = props.hasOwnProperty('overviewParagraphsLimit') ? props.overviewParagraphsLimit : 1

  const applyRegex = props.hasOwnProperty('applyRegex') ? props.applyRegex : true

  let layout = 1;

  const [ modalState, setModalState ] = useState( "close" );

  const handleShow = ( state ) => {
    setModalState( state );
  }

  const handleHide = () => {
    setModalState( "close" );
  }

  const [ isExpanded, setExpanded ] = useState( false );
  const { getCollapseProps } = useCollapse({
    isExpanded
  });

  let text = null
  if (applyRegex) {
    text = Checkers.isValidString(props.text) ? props.text.match(/<(.)*>.*?<\/\1>/g) : null;
  } else {
    text = Checkers.isValidString(props.text) ? props.text : null;
  }
  let intro_text = '';


  if ( props.text===null ) {
    text = "";
  } else if ( props.text!=undefined && (!Checkers.isValidArray( text ) || text.length==1) ) {
    text = props.text.replace( "<p></p>", "" );
    text = text.split( "</p>" ).filter( Boolean );
  }

  if ( props.text===null ) {
    text = "";
  } else if ( !Checkers.isValidArray( text ) || text.length==1 ) {
    layout = 2;
    intro_text = props.text!=undefined ? props.text.slice( 0, props.letters ) : ''
  }

  return (
    <>
      {
        layout == 1 ?
          Checkers.isValidArray( text ) &&
            <>
              <div className={props.className}>
                {
                  text.map( ( item, key ) => {
                    if ( key < overviewParagraphsLimit ) {
                      return (
                          <>
                            <div key={key.toString()} >
                              <p dangerouslySetInnerHTML={{ __html: item }} />
                            </div>
                          </>
                      )}
                  })
                }
                <div {...getCollapseProps({})}>
                  {
                    text.map( ( item, key ) => {
                      if ( key >= overviewParagraphsLimit ) {
                          return (
                              <>
                                  <div key={key.toString()} >
                                      <p dangerouslySetInnerHTML={{ __html: item }} />
                                  </div>
                              </>
                          )}
                    })
                  }
                </div>
                {
                  Checkers.isValidArray( text ) && text.length > 1 &&
                      <p>
                        <button className="btn-link text-link" onClick={() => setExpanded( ( value ) => !value )}>
                          {
                            isExpanded ? <span className={btnTextColor(props.darkMode)}>{t('common.readLess')}</span> : <span className={btnTextColor(props.darkMode)}>{t('common.readMore')}</span>
                          }
                        </button>
                      </p>
                }
              </div>
            </>
          :
          (
              props.text !=undefined && layout==2 && ( props.text.length!=intro_text.length || Checkers.isValidString( props.image ) ) ?
              <>
                <div className={props.className}>
                  <p dangerouslySetInnerHTML={{ __html: intro_text + ( props.text.length!=intro_text.length ? "..." : "" ) }}/>
                </div>
                {
                  <p>
                    <button className="btn-link text-link" onClick={() => handleShow( 'distincts_read_more' )}>
                      {
                        isExpanded ? <span className={btnTextColor(props.darkMode)}>{t('common.readLess')}</span> : <span className={btnTextColor(props.darkMode)}>{t('common.readMore')}</span>
                      }
                    </button>
                  </p>
                }

                <RightModal
                  modalName={'distincts_read_more'}
                  className="slide_right"
                  Title={
                    <>
                      {Checkers.isValidString(props.faIcon) && <i className={'fa ' + props.faIcon + ' m-r-10'}/>}
                      {props.title}
                    </>
                  }
                  BodyRender={
                    <>
                      {
                        Checkers.isValidString(props.image) &&
                          // eslint-disable-next-line @next/next/no-img-element
                          <img src={props.image} alt={props.title} className="img-responsive w-100 m-b-20" style={{ borderRadius: 8 }}/>
                      }
                      <div dangerouslySetInnerHTML={{ __html: props.text }} />
                    </>
                  }
                  modalSize="lg"
                  closeModal={() => {
                    handleHide()
                  }}
                  show={modalState === 'distincts_read_more'}
                />
              </>
              :
                <>
                  <div className={props.className}>
                    <p dangerouslySetInnerHTML={{ __html: intro_text }} />
                  </div>
                </>
          )
      }
    </>
  )
}
